import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import Link from 'components/core/Link';
import { FlowLogoImg, OneparkLogoBlueImg } from 'components/img/AssetImg';
import AppIcon from 'components/icons/AppIcon';
import {
  navigateToContactUs,
  navigateToFaq,
  navigateToHowItWorks,
  navigateToTermsOfService,
} from 'cpmMore/navigation';
import APPCONFIG from 'constants/Config';

const APP_VERSION = __APP_VERSION__; // eslint-disable-line no-undef

const useStyles = makeStyles((theme) => ({
  upperFooter: {
    backgroundColor: '#E5E5E5',
    padding: '32px',
    fontSize: 16,
  },
  gradientLine: {
    height: '4px' /* Thickness of the line */,
    background:
      'linear-gradient(90deg, rgba(122,56,191,1) 0%, rgba(12,179,228,1) 50%, rgba(4,36,156,1) 100%)' /* gradient colors */,
  },
  lowerFooter: {
    padding: '32px 32px 8px 32px',
    color: theme.palette.primary.main,
    backgroundColor: '#F9F9F9',
  },
  faq: {
    fontSize: 15,
    marginBottom: '30px',
  },
  legal: {
    fontSize: 13,
  },
  poweredBy: {
    fontSize: 12,
    fontWeight: '400',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 15,
    marginBottom: '30px',
  },
  link: {
    fontWeight: '500',
  },
  version: {
    fontSize: 11,
  },
}));

const CpmClientFooter = ({
  intl,
}) => {
  const classes = useStyles();

  return (
    <footer>
      {/*  gradient line  */}
      <div className={classes.gradientLine} />
      {/* ----- Upper Footer ----- */}
      <div className={`d-flex flex-column flex-md-row text-center justify-content-center ${classes.upperFooter}`}>
        <div className="mr-md-1">
          <LocalizedMessage id="footer.askQuestion" />
        </div>
        <Link onClick={navigateToContactUs} underline="always">
          <LocalizedMessage id="footer.contactUs" />
        </Link>
      </div>
      {/* ----- Lower Footer ----- */}
      <div className={classes.lowerFooter}>
        {/* FAQ */}
        <div className={`text-center ${classes.faq}`}>
          <div className="col-12">
            <Link onClick={navigateToHowItWorks} underline="always">
              <LocalizedMessage id="info.howWork" />
            </Link>
          </div>
          <div className="col-12">
            <Link onClick={navigateToFaq} underline="always">
              <LocalizedMessage id="footer.FAQ" />
            </Link>
          </div>
        </div>

        {/* Contacts */}
        <div className={`d-flex flex-column flex-md-row text-center justify-content-center ${classes.container}`}>
          <div className="d-flex align-items-center justify-content-center mr-md-3">
            <AppIcon id="itemEmailOutline" />
            <div className={`ml-1 ${classes.link}`}>
              <Link mailto={intl.formatMessage({ id: 'info.supportEmail' })} underline="always">
                {intl.formatMessage({ id: 'info.supportEmail' })}
              </Link>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-center">
            <AppIcon id="itemPhoneOutline" />
            <div className={`ml-1 ${classes.link}`}>
              <Link tel={intl.formatMessage({ id: 'info.supportPhoneNumber' })} underline="always">
                {intl.formatMessage({ id: 'info.supportPhoneNumber' })}
              </Link>
            </div>
          </div>
        </div>

        {/* Legal Section */}
        <div style={{ paddingBottom: 30 }}>
          <ul
            className="d-flex justify-content-center p-0 mx-auto mb-2"
            style={{
              width: 'fit-content', gap: '3px', lineHeight: '110%', flexWrap: 'wrap',
            }}
          >
            <Link onClick={navigateToTermsOfService} underline="always">
              <LocalizedMessage id="footer.termsConditions" />
            </Link>
            <span>|</span>
            <Link underline="always">
              <LocalizedMessage id="footer.CGU" />
            </Link>
            <span>|</span>
            <Link underline="always">
              <LocalizedMessage id="footer.siteMap" />
            </Link>
            <span>|</span>
            <Link underline="always">
              <LocalizedMessage id="footer.confidentialityPolicy" />
            </Link>
            <span>|</span>
            <Link underline="always">
              <LocalizedMessage id="footer.cookies" />
            </Link>
          </ul>
          <div className={`text-center ${classes.legal}`}>
            <LocalizedMessage id="footer.copyright" values={{ year: APPCONFIG.year, version: APP_VERSION }} />
          </div>
        </div>

        {/* Logo Section */}
        <div className="col-12 text-center">{FlowLogoImg(80)}</div>
        <div className={`col-12 text-center mt-2 ${classes.poweredBy}`}>
          <span className="mr-1">
            Powered by
            {' '}
          </span>
          <a href="https://www.onepark.fr" target="_blank" rel="noopener noreferrer">
            {OneparkLogoBlueImg(null, 25)}
          </a>
        </div>
      </div>
    </footer>
  );
};

CpmClientFooter.propTypes = {
  intl: PropTypes.object.isRequired,
};

module.exports = compose(
  injectIntl,
)(CpmClientFooter);



// WEBPACK FOOTER //
// ./components/footer/CpmClientFooter.js